/*global $, localStorage, location*/

var showOrHideToolbar = function(duration) {
    if(localStorage.getItem('toolbar') === 'show') {
        if($('body').hasClass('si-hidden')) {
            $('.si-toggle-container.si-pos-east').css('right', -54);
            $('body').removeClass('si-hidden');
        }
        $('.edit-bar-wrapper').show(duration);
        $('.plone-toolbar-left-expanded').animate({'padding-left': 120}, duration);
        $('#ugent-membertools').hide(duration);
        $('.si-toggle-container.si-pos-east').animate({'right': 1}, duration);
    } else {
        if(duration == 0){
            $('body').addClass('si-hidden');
        }
        $('.edit-bar-wrapper').hide(duration);
        $('.plone-toolbar-left-expanded').animate({'padding-left': 0}, duration);
        $('#ugent-membertools').show(duration);
        $('.si-toggle-container.si-pos-east').animate({'right': -54}, duration);
    }
}

var toggleToolbar = function(event) {
    event.preventDefault();
    var currentValue = localStorage.getItem('toolbar');
    var newValue = currentValue === 'show' ? 'hide' : 'show';
    localStorage.setItem('toolbar', newValue);
    showOrHideToolbar(150);
}

$(function() {
    // Turn login URL into a CAS login url
    var loginText = $('#personaltools-login').text();
    var loginUrl = "/login?came_from=" + encodeURIComponent(location.href);
    $('#personaltools-login').replaceWith('<a href="' + loginUrl + '">' + loginText + '</a>');
    // Move some form fields
    $('#fieldset-default').prepend($('#formfield-form-widgets-IShortName-id'));
    $('form.view-name-add-Event #formfield-form-widgets-IBasic-title').after($('form.view-name-add-Event #formfield-form-widgets-ICategorization-language'))
    $('body.portaltype-event #formfield-form-widgets-IBasic-title').after($('body.portaltype-event #formfield-form-widgets-ICategorization-language'))
    // Show or hide toolbar
    if($('.edit-bar-wrapper').length) { // Don't bother if there is no toolbar
        $('#edit-bar #personaltools-switch_mode, .pageheader #personaltools-switch_mode').on('click', toggleToolbar);
        showOrHideToolbar(0);
    }
    // hide some field
    $('.template-event #formfield-form-widgets-IShowHideDescription-show_description, .template-news-item #formfield-form-widgets-IShowHideDescription-show_description').hide()
});
